import React, { Component } from 'react'
import HttpServices from '../../../../utils/Http.services'
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'
import FixedView from '../../../FixedView'
import FormViewer from '../../../FormViewer'
import ProfileImageInput2 from '../../../inputs/ProfileImageInput2'
import SwitchInput from '../../../inputs/SwitchInput'
import TextInput from '../../../inputs/TextInput'
import Modal from '../../../Modal'
import Members from '../sideBar/Members'
import CustomLoader from '../../../CustomLoader'
import StagesManager from '../../../StagesManager'
import ButtonAnimated from '../../../buttons/ButtonAnimated'
import { getBoundingClientRect } from '../../../../utils/functions'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../../stores/actionsList';

class CreateGroup extends Component {

    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,
        groupName: '',
        description: '',
        selectedImage: {},
        headers: [
            { key: 'hubs', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}messenger.hubs', address: 'searchHubs', fields: { title: 'username', value: '_id', image: 'image' }, filter: { applet: '{{appletId}}', appletHub: '{{appletHub}}' }, type: 'api', isSearchable: false, placeholder: '{{lang}}messenger.Select', required: true } },
        ],
        contactsList: [],
        selectedList: [],
        selectedIds: [],
        search: '',
        userinfo: { username: "@Gedrich98", des: "this is a test bio description that's it the rest is just a usless words just to make this test a little bit longer for testing the UI.", number: "+989021377118" },
        searchBoxHeight: 51.2,
        isLoading: false
    }


    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openMemberView = () => {
        this.memberView.showView()
    }

    changeValue = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }

    createGroup = () => {
        if (this.state.groupName && this.state.selectedList.length > 0) {

            let data = { frames: [] }
            if (Array.isArray(this.state.selectedList)) {
                for (let i = 0; i < this.state.selectedList.length; i++) {
                    const frame = this.state.selectedList[i];
                    data.frames.push(frame._id)
                }
            }
            data.name = this.state.groupName
            data.description = this.state.description

            if (Object.values(this.state.selectedImage).length != 0) {
                HttpServices.fileUpload(this.state.selectedImage, null, null, (image) => {

                    data.image = image
                    this.props.createGroup(data)
                })
            }
            else {

                this.props.createGroup(data)
            }
        }
        else if (this.state.groupName == '') {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.Name Required', description: '{{lang}}errors.First fill name input' })
        }
        else if (this.state.selectedList.length == 0) {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.User Required', description: '{{lang}}errors.First select a user' })
        }
    }

    search = (value) => {
        this.setState({ search: value }, () => {
            let body = { text: this.state.search }
            this.setState({ isLoadingData: true })
            HttpServices.request('searchHubs', body, (fetchResult, fetchError) => {
                this.setState({ isLoadingData: false })
                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }
                this.setState({ contactsList: fetchResult.info, contactsListFiltered: fetchResult.info }, () => { })
            })
            // let contactsListFiltered = this.state.contactsList.filter((e) =>
            //     e.fullname?.toLowerCase().includes(this.state.search?.toLowerCase())
            // )
            // this.setState({ contactsListFiltered }, () => {
            // })
        })
    }
    componentDidMount = () => {
        let body = {}
        // console.log('&searchHubs')
        this.setState({ isLoadingData: true })
        HttpServices.request('getMessengerApplets', body, (fetchResult, fetchError) => {

            // HttpServices.request('searchHubs', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            this.setState({ contactsList: fetchResult.info, contactsListFiltered: fetchResult.info }, () => { })
        })
    }

    selectContact = (prop, frame) => {

        console.log(prop)
        console.log(frame)

        let searchBox = this.searchBox
        let list = this.list
        let selectedList = this.state.selectedList
        let selectedIds = this.state.selectedIds

        // console.log(prop)
        if (selectedIds.includes(frame._id)) {
            let index = selectedIds.indexOf(frame._id)

            selectedList.splice(index, 1)
            selectedIds.splice(index, 1)
        }
        else {
            let myFrame = JSON.parse(JSON.stringify(frame))
            myFrame.hub = prop.hub
            selectedList.push(myFrame)
            selectedIds.push(myFrame._id)

        }
        if (this.state.search != null && this.state.search != '') {
            // this.search()
            this.setState({ contactsListFiltered: this.state.contactsList })
        }

        this.setState({ selectedList, selectedIds, search: '' }, () => {
            if (this.searchInput) {
                this.searchInput.focus()
            }
            if (!searchBox.style) {
                searchBox.style = {}
            }
            // searchBox.style.height = 'auto';
            // searchBox.style.height = (searchBox.clientHeight) + "px";
            // let height = getBoundingClientRect(searchBox).height
            if (!list.style) {
                list.style = {}
            }
            // list.style.height = 'auto';
            // list.style.height = (list.clientHeight) + "px";
            let listHeight = getBoundingClientRect(list).height
            console.log("listHeight", listHeight)
            list.scrollTo({
                top: listHeight,
                behavior: 'smooth'
            })
            // this.setState({ searchBoxHeight: height })
        })
    }


    goToGroupInfo = () => {


        this.stageManager.changeStage('groupInfo')
    }

    render() {
        return (
            <div className='h-100'>
                <StagesManager ref={el => this.stageManager = el} height={'100%'}>
                    <div className='h-100 d-flex flex-column' stage={0} stageName={'contactsList'} >
                        <div className="pb-1 " style={{}}>
                            <div className="flexcb pt-2 px-2 mb-1" style={{}}>
                                <div className='flexc' style={{}}>
                                    <button className="br-30 flexcc p-2" onClick={() => { this.props.changeStage('mainControl') }} style={{ display: this.props.isDesktop ? 'none' : 'flex', backgroundColor: '#eee', height: 25, width: 25 }} >
                                        <img src={'/assets/icons/useful/angle-right.svg'} height="18px" className={this.props.language == 'fa' ? "" : " rotate-180"} />
                                    </button>
                                    <p className=" text-normal text-bold px-1">{translate("New group")}</p>
                                </div>

                                <div className='flexc'>

                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => this.goToGroupInfo()}
                                        title={translate('Next')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={this.props.background ?? ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                        width={'100%'}
                                    />
                                </div>

                            </div>


                            <div ref={el => this.searchBox = el} className="mx-0  " style={{}}>
                                <div ref={el => this.list = el} className='flexc py-2 px-2' style={{ backgroundColor: '#f6f6f6', borderRadius: 0, maxHeight: '120px', flexWrap: 'wrap', overflow: 'auto', }}>
                                    {/* <div ref={el => this.list = el} className='flexc' style={{ flexWrap: 'wrap' }}> */}
                                    {/* {Array.isArray(this.state.selectedList) && this.state.selectedList.map((item, index) => { */}
                                    {/* return (
                                            <> */}
                                    {Array.isArray(this.state.selectedList) && this.state.selectedList.map((item, sindex) => {
                                        return (
                                            <div key={item._id} className='br-100 flexcc px-2 mx-1 mb-1' style={{ background: ' linear-gradient(90deg, #ddd, #ddd)', maxWidth: "90%" }}>
                                                <img className='br-20' src={imageAddress(item.hub?.image, 'hub', 'mini')} alt='' style={{ width: 14, height: 14 }} />
                                                <div className='flex-1' style={{ minWidth: 0 }}>
                                                    <p className='font-size-11 text-semibold pld-2 prd-1 py-1 w-100' style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', }}>{item.hub?.fullname}</p>
                                                </div>
                                                <button className="flexcc" onClick={() => this.selectContact(null, item)}>
                                                    <img src="/assets/icons/remove-white.svg" className='invert' width={10} alt='' />
                                                </button>
                                            </div>
                                        )

                                    })}
                                    {/* </> */}
                                    {/* ) */}
                                    {/* })} */}
                                    {/* </div> */}
                                    <input ref={el => this.searchInput = el} onChange={e => this.search(e.target.value)} value={this.state.search} className="py-1 px-2  font-size-11" placeholder={translate('How to be added?')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                                </div>
                            </div>

                        </div>

                        {/* <div className="flexcb pt-2 pb-2 px-2" style={{}}>
                            <div className='flexcb w-100'>

                                <div className='flexc'>
                                    <button className="br-30 flexcc p-2" onClick={() => { this.props.changeStage('mainControl') }} style={{ display: this.props.isDesktop ? 'none' : 'flex', backgroundColor: '#eee', height: 25, width: 25 }} >
                                        <img src={'/assets/icons/useful/angle-right.svg'} height="18px" className={this.props.language == 'fa' ? "" : " rotate-180"} alt='' />
                                    </button>

                                    <p className="text-normal text-bold px-1">{(translate("messenger.New group"))}</p>
                                </div>

                                <div className='flexc'>
                                  
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => this.stageManager.changeStage('groupInfo')}
                                        title={translate('Next')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={this.props.background ?? ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                        width={'100%'}
                                    />
                                </div>
                            </div>
                        </div> */}
                        {!this.props.isLoader ? (
                            <>

                                <div className='br-10 d-flex flex-column  pb-1 scroll-no-scrollbar' style={{ height: `calc(100% - (${66 + this.state.searchBoxHeight}px)` }} >
                                    {/* {this.state.contactsListFiltered?.map((prop) => {
                                        return (
                                            <button key={prop._id} className='text-start' onClick={() => this.selectContact(prop)}>
                                                <div className='flexcb w-100 py-2 hover-gray2 br-5 px-2'>
                                                    <div className='flexc'>
                                                        <img className='br-50' style={{ objectFit: "cover" }} width={30} height={30} src={imageAddress(prop?.image, 'profile')} />
                                                        <div className='mld-2'>
                                                            <p>{checkTranslation(prop.fullname)}</p>
                                                            <p className="" style={{ color: '#567', fontSize: 11, textAlign: 'start' }}>{this.props.language == 'fa' ? prop?.username + '@' : '@' + prop?.username}</p>
                                                        </div>
                                                    </div>
                                                    <div className=''>
                                                        <img className='flexcc' width={20} height={20} src={this.state.selectedIds.includes(prop._id) ? '/assets/icons/messenger/check-fill.svg' : '/assets/icons/messenger/check.svg'} />
                                                    </div>
                                                </div>
                                            </button>
                                        )
                                    })} */}
                                    {this.state.contactsListFiltered?.map((item) => {
                                        return (
                                            <div className=" w-100 bb-gray-messenger-list prd-3 ">
                                                <button className={" w-100 flexc py-2 br-4 pl-2 " + (item.frames?.length == 1 ? " hover-gray2 " : '')} style={{ transition: 'all 0.5s', cursor: item.frames?.length > 1 ? 'not-allowed' : null }} onClick={() => { if (item.frames.length == 1) { this.selectContact(item, item.frames[0]) } }}>
                                                    <div className='flexc flex-1'>
                                                        <div>
                                                            <div className=" flexcc" style={{}}>
                                                                <img src={imageAddress(item?.hub?.image, "profile", 'thumb')} style={{ width: 30, height: 30, borderRadius: 30, objectFit: 'cover' }} alt="" />
                                                            </div>
                                                        </div>
                                                        <div className="px-2 w-100 text-start">
                                                            <div className="flexcb w-100">
                                                                <p className="mb-0 text-bold" style={{ fontSize: 13, color: '#202020' }}>{item.hub?.fullname}</p>

                                                            </div>

                                                            <p className="" style={{ color: '#567', fontSize: 11 }}>@{item.hub?.username}</p>


                                                        </div>
                                                    </div>
                                                    {item.frames?.length == 1 && (
                                                        <div className=''>
                                                            <img className='flexcc' width={20} height={20} src={this.state.selectedIds.includes(item.frames[0]?._id) ? '/assets/icons/messenger/check-fill.svg' : '/assets/icons/messenger/check.svg'} alt='' />
                                                        </div>
                                                    )}

                                                </button>

                                                {Array.isArray(item.frames) && item.frames?.length > 1 && (
                                                    <div className=" pt-0 pb-1 pld-2">
                                                        {item.frames.map((frame, index) => {
                                                            return (
                                                                <button onClick={() => { this.selectContact(item, frame) }} className="w-100 text-start br-4 flexc hover-gray2 transition-all pld-3 " style={{ paddingTop: 5, paddingBottom: 5 }}>
                                                                    <div className='flexc flex-1' style={{ minWidth: 0 }}>

                                                                        <div className=" flexcc mrd-1 position-relative" style={{}}>
                                                                            <img src={imageAddress(frame?.image, "messenger", 'thumb')} style={{ width: 18, height: 18, borderRadius: 18, objectFit: 'cover' }} alt="" />
                                                                            <div className="flexcc position-absolute" style={{ top: 10, left: 10 }}>
                                                                                <img src={imageAddress(frame.applet?.image, "applet", 'thumb')} style={{ width: 10, height: 10, borderRadius: 10, objectFit: 'cover' }} alt="" />
                                                                            </div>
                                                                        </div>
                                                                        <div className=" flex-1" style={{ minWidth: 0 }} >
                                                                            <p className="font-size-13 mld-2  w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{checkTranslation(frame.name)} - {checkTranslation(frame.applet?.name)}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className='pld-3'>
                                                                        <img className='flexcc' width={20} height={20} src={this.state.selectedIds.includes(frame._id) ? '/assets/icons/messenger/check-fill.svg' : '/assets/icons/messenger/check.svg'} alt='' />
                                                                    </div>

                                                                </button>
                                                            )
                                                        })}
                                                    </div>
                                                )}

                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        ) : (
                            <div className='h-100 flexcc'>
                                <CustomLoader color={"#007aff"} isLoading={true} />
                            </div>
                        )}
                    </div>
                    <div className='h-100' stage={1} stageName={'groupInfo'} >

                        <div className="flexcb pt-2 px-2 mb-1" style={{}}>
                            <div className='flexc' style={{}}>
                                <button className="br-30 flexcc p-2" onClick={() => { this.stageManager.changeStage('contactsList') }} style={{ display: this.props.isDesktop ? 'none' : 'flex', backgroundColor: '#eee', height: 25, width: 25 }} >
                                    <img src={'/assets/icons/useful/angle-right.svg'} height="18px" className={this.props.language == 'fa' ? "" : " rotate-180"} alt='' />
                                </button>
                                <p className=" text-normal text-bold px-1">{translate("Group Info")}</p>
                            </div>

                            <div className='flexc'>

                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.createGroup()}
                                    title={translate('Create')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={'#fff'}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                    width={'100%'}
                                />
                            </div>

                        </div>

                        {/* <div className='px-2'>
                            <div className='flexcb pt-3'>
                                <p className="text-bold text-small px-1">{(translate("messenger.New group"))}</p>
                                <div className='flexc'>
                                    <div className="px-1">
                                        <ButtonAnimated
                                            onClick={() => this.stageManager.changeStage('contactsList')}
                                            title={translate('Back')}
                                            bg={'linear-gradient(to right, #eee, #eee)'}
                                            textColor={'#777'}
                                            width={'100%'}
                                        />
                                    </div>
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => this.createGroup()}
                                        title={translate('Create')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        isLoading={this.props.isLoading}
                                        textColor={'#fff'}
                                        bg={this.props.background ?? ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                        width={'100%'}
                                    />
                                </div>
                            </div>
                        </div> */}
                        <div className='w-100 '>
                            <div className='flexc px-2 pt-2 pb-2 w-100 ' style={{ backgroundColor: '#f3f5f7' }}>
                                <div className='br-50' style={{ border: '1px solid #ddd' }}>
                                    <ProfileImageInput2 openModal={this.props.openModal} setData={this.props.setData} data={this.state.image} selectedImage={this.state.selectedImage} changeValue={this.changeValue} header={{ key: 'image', type: 'ProfileImageInput', theme: 'transparent', information: { label: '{{lang}}image', placeholder: '{{lang}}image', size: 50, placeHolderImage: '', inputClass: 'none', required: false, cropper: true, ratio: '1:1', single: true } }} colors={this.props.colors} />
                                </div>
                                <div className='mld-2 w-100'>
                                    <div className='flexcc w-100 br-10  px-1 py-2 text-semibold big-text-input' >
                                        {/* <input className='transparent-input ' placeholder={translate('Group name')} style={{ fontSize: 15, fontWeight: 500 }} /> */}
                                        <TextInput data={this.state.groupName} changeValue={this.changeValue} header={{ key: 'groupName', information: { rows: 1, placeholder: translate('messenger.Group name') }, }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='w-100 px-2 py-2' style={{}}>
                            <div className='flexcc w-100 br-10  px-2 py-2'>
                                <TextInput data={this.state.description} changeValue={this.changeValue} header={{ key: 'description', information: { rows: 1, placeholder: translate('messenger.Description') }, }} />
                            </div>
                        </div>
                        <div className='mx-2 scroll-no-scrollbar pb-2' style={{ overflow: 'auto', borderTop: "1px solid #eee", height: 'calc(100% - 199.2px)' }}>
                            <div className='br-10 d-flex flex-column' style={{}}>

                                <p className='text-semibold text-normal mt-2 mb-2 mx-1'>{translate("Group members")}</p>
                                {Array.isArray(this.state.selectedList) && this.state.selectedList?.map((prop) => {
                                    // let selected = false
                                    // if (this.state.selectedIds.includes(prop._id)) {
                                    //     selected = true
                                    // }
                                    return (
                                        <>
                                            {/* {Array.isArray(this.state.selectedList) && this.state.selectedList.map((select, sindex) => {
                                                if (prop._id == select) */}
                                            {/* return ( */}
                                            <div key={prop._id} >
                                                <div className='flexcb w-100 mb-2 br-5 px-2'>
                                                    <div className='flexc'>
                                                        <img className='br-50' style={{ objectFit: "cover" }} width={30} height={30} src={imageAddress(prop?.hub?.image, 'profile')} alt='' />
                                                        <div className='mld-2'>
                                                            <p className='text-semibold font-size-13'>{checkTranslation(prop.hub?.fullname)}</p>

                                                            <div className=" flex-1" style={{ minWidth: 0 }} >
                                                                <p className="font-size-12   w-100" style={{ color: '#567', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{checkTranslation(prop.name)} - {checkTranslation(prop.applet?.name)}</p>
                                                            </div>
                                                            {/* <p className="" style={{ color: '#567', fontSize: 11, textAlign: 'start' }}>{'@' + prop?.hub?.username}</p> */}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            {/* ) */}
                                            {/* })} */}
                                        </>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </StagesManager>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateGroup);